// import    { useState } from 'react';
import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { StyledFormGroup } from '../../../../../Components/Reuseables';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../../_helpers/_methods';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';
import CheckBoxWithQuestion from './CheckBoxWithQuestion';
import updateAction from './updateAction';
import { useSelector } from 'react-redux';

function IndividualStep2() {
  scrollTo(top);
  const { id, edit: isEdit } = useParams();

  const [options, setOptions] = useState([]);
  const { actions } = useStateMachine({ updateAction });
  const { state } = useStateMachine({ updateAction });
  const lang = useSelector((state) => state.local.local);
  const navigate = useNavigate();
  const rosterData = useSelector((state) => state.rosters.rosters);
  const [defaultExpertise, setDefaultExpertise] = useState({});

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });

  useEffect(() => {
    if (isEdit) {
      if (rosterData && Array.isArray(rosterData?.user?.expertise)) {
        const temp = {};
        rosterData.user.expertise.forEach((expertise) => {
          temp[expertise.thematic_area] = expertise;
        });
        setDefaultExpertise(temp);
      }
    }
    if (state.experties && Array.isArray(state.experties)) {
      const temp = {};
      state.experties.forEach((expertise) => {
        temp[expertise.thematic_area] = expertise;
      });
      setDefaultExpertise(temp);
    }
  }, [rosterData]);

  useEffect(() => {
    if (isEdit) {
      if (rosterData) {
        rosterData.other_experience &&
          setValue('roster_other_experties', rosterData.other_experience.split(','));
      }
    }
  }, [rosterData]);
  useEffect(() => {
    const getThematicArea = async () => {
      try {
        let response = await fetchWrapper.get('/thematicarea/?limit=400');
        response = response.data.results.map((thematicarea) => ({
          label: thematicarea.title_nepali,
          value: false,
          id: thematicarea.id,
          name: thematicarea.title_nepali
        }));
        setOptions(response);
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    getThematicArea();
  }, []);

  const handleChange = (e) => {
    console.log(e.target.value);
  };
  const location = useLocation();

  const onSubmit = (data) => {
    let thematicAreaIDs = [];

    if (isEdit) {
      thematicAreaIDs = (rosterData.expertises || [])?.map((item) => ({
        thematic_area: item.thematic_area,
        experties: item.id
      }));
    }
    let thematic_area = Object.keys(data.thematic_area)
      .map((id) => {
        if (data.thematic_area[id]) {
          const index = thematicAreaIDs?.findIndex((item) => +item.thematic_area === +id);

          if (index === -1)
            return {
              thematic_area: id,
              year: data.thematic_area[id].experience,
              training_taken: data.thematic_area[id].training_taken,
              training_given: data.thematic_area[id].training_given
            };
          else {
            return {
              id: thematicAreaIDs[index]?.experties,
              thematic_area: id,
              year: data.thematic_area[id].experience,
              training_taken: data.thematic_area[id].training_taken,
              training_given: data.thematic_area[id].training_given
            };
          }
        }
      })
      .filter((data) => data);

    data = { ...data, experties: thematic_area };
    delete data.thematic_area;
    actions.updateAction(data);

    let path = location.pathname.split('/');
    if (isEdit) {
      navigate(`/admin/rosters/individual/${id}/edit/3`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/individual_apply/3')
        : navigate('/rosters/individual_apply/3');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="">
        <div className="mt-4">
          <h5 className="">
            <FormattedMessage id="thematic_area_and_related_experience" />
          </h5>
        </div>
        <div className="my-2 px-2">
          <FormattedMessage id="choose_thematic_area" />
        </div>
        <div className="row">
          <div className="col-md-12 ps-4 ">
            <StyledThematicAreaWrapper>
              {options.map((option) => {
                return (
                  <div className="list-group-item " key={option.id}>
                    <CheckBoxWithQuestion
                      register={register}
                      errors={errors}
                      defaultValue={defaultExpertise}
                      option={option}
                    />
                  </div>
                );
              })}
            </StyledThematicAreaWrapper>
          </div>

          <div className="col-md-12">
            <h5 className="mb-2 mt-3">
              <FormattedMessage id="civil_service_experience" />
            </h5>

            <div className="ps-2">
              <StyledFormGroup className="list-group-item">
                <FormGroup
                  type="radio"
                  id="roster_civil_service_experience"
                  register={register}
                  error={errors}
                  onChange={(e) => handleChange(e)}
                  options={[
                    {
                      label: lang === 'ne' ? 'छ' : 'Yes',
                      value: 'yes',
                      id: 'roster_civil_service_true',
                      name: 'roster_civil_service_experience'
                    },
                    {
                      label: lang === 'ne' ? 'छैन' : 'No',
                      value: 'no',
                      id: 'roster_civil_service_false',
                      name: 'roster_civil_service_experience'
                    }
                  ]}
                  defaultValue={
                    state?.roster_civil_service_experience ||
                    (isEdit && (rosterData?.civil_service ? 'yes' : 'no'))
                  }
                />
              </StyledFormGroup>
            </div>
          </div>
          <div className="col-md-12">
            <h5 className="mb-2 mt-3">
              <FormattedMessage id="other_experience" />
            </h5>
            <div className="ps-2">
              <StyledFormGroup className="list-group-item">
                <FormGroup
                  type="checkbox"
                  id="roster_other_experties"
                  register={register}
                  error={errors}
                  onChange={(e) => handleChange(e)}
                  defaultValue={
                    state?.roster_other_experties ||
                    (isEdit &&
                      rosterData &&
                      rosterData.other_experience &&
                      rosterData.other_experience.split(','))
                  }
                  options={[
                    {
                      label: lang === 'ne' ? 'अन्य सरकारी निकाय' : 'Other Government Bodies',
                      value: 'अन्य सरकारी निकाय',
                      id: 'roster_other_experties_अन्य सरकारी निकाय',
                      name: 'roster_other_experties'
                    },
                    {
                      label: lang === 'ne' ? 'गैर सरकारी संघ/संस्था' : 'NGO/Institution',
                      value: 'गैर सरकारी संघ/संस्था',
                      id: 'roster_other_experties_गैर सरकारी संघ/संस्था',
                      name: 'roster_other_experties'
                    },
                    {
                      label: lang === 'ne' ? 'निजी संघ/संस्था' : 'Private Association/Institution',
                      value: 'निजी संघ/संस्था',
                      id: 'roster_other_experties_निजी संघ/संस्था',
                      name: 'roster_other_experties'
                    },
                    {
                      label: lang === 'ne' ? 'अन्य' : 'Others',
                      value: 'अन्य',
                      id: 'roster_other_experties_अन्य',
                      name: 'roster_other_experties'
                    }
                  ]}
                />
              </StyledFormGroup>
            </div>
          </div>
        </div>

        <div className="">
          <hr />
          <NavigationButtonGroup
            backTo={isEdit ? '/admin/rosters/individual_list' : ''}
            // showSubmit={id}
          />
        </div>
      </div>
    </form>
  );
}

export default IndividualStep2;

const StyledThematicAreaWrapper = styled.div`
  max-height: 600px;
  overflow-y: auto;
`;
